import { Box, Button, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { primary } from '../../../../constants/theme/colors.tsx';

interface DataModalHeaderProps {
  setIsOpen: (value: boolean) => void;
  title: string;
}

export const DataModalHeader = (props: DataModalHeaderProps) => {
  const { setIsOpen, title } = props;

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Box className="header">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'right',
          alignItems: 'middle',
        }}
      >
        <Button
          onClick={() => onClose()}
          variant="transparent"
          sx={{ color: 'black' }}
        >
          <CloseIcon />
        </Button>
      </Box>

      <DialogTitle
        sx={{
          padding: '12px',
          color: primary.main,
          fontSize: '45px',
          textAlign: 'center',
        }}
        id="data-modal-title"
      >
        {title}
      </DialogTitle>
    </Box>
  );
};
